import { observableValue, type ISettableObservable } from '@vscode/observables';

export function createQueryParamObservable(
  owner: object,
  paramName: string,
): ISettableObservable<string | undefined> {
  const params = new URLSearchParams(location.search);
  const initialValue = params.get(paramName) || undefined;

  const obs = observableValue<string | undefined>(owner, initialValue);

  window.addEventListener('popstate', () => {
    const p = new URLSearchParams(location.search);
    obs.set(p.get(paramName) || undefined, undefined);
  });

  const originalSet = obs.set.bind(obs);
  obs.set = (value: string | undefined, tx: undefined) => {
    const p = new URLSearchParams(location.search);
    if (!value) {
      p.delete(paramName);
    } else {
      p.set(paramName, value);
    }
    const search = p.toString();
    const newUrl = location.pathname + (search ? '?' + search : '') + location.hash;
    history.replaceState(history.state, '', newUrl);
    originalSet(value, tx);
  };

  return obs;
}

export function buildQueryParamUrl(paramName: string, value: string): string {
  const p = new URLSearchParams(location.search);
  p.set(paramName, value);
  return location.pathname + '?' + p.toString();
}
